const $backToTop = document.getElementById('back_to_top');
const masthead = document.querySelector('.masthead') || document.querySelector('.masthead-home');
let visibleTreshold = 200;

$backToTop.addEventListener('click', () => {
  document.documentElement.scrollTop = 0;
});

/*
  If the page has a masthead, we'll use
  the bottom of it as a treshold for when
  the scroll to top button should show up.
*/
if (masthead) {
  const mastheadHeight = masthead.offsetHeight;
  const mastheadTopOffset = masthead.offsetTop;
  visibleTreshold = mastheadTopOffset + mastheadHeight;
}

window.onscroll = function () {
  if (document.body.scrollTop > visibleTreshold || document.documentElement.scrollTop > visibleTreshold) {
    $backToTop.classList.remove("is--hidden");
  } else {
    $backToTop.classList.add("is--hidden");
  }
};